import { defineMessages } from 'react-intl';

export default defineMessages({
  SEE_ACHIEVEMENTS: {
    defaultMessage: 'Voir mes badges',
  },
} as const);
